import restService from "../rest-service/RestService";
import { FeatureConstants } from "./Models";

const FeaturesDataService = {

    evaluateFeatures: async function(features: FeatureConstants[], signal?: AbortSignal): Promise<any[]> {
        const response = await restService.post<FeatureConstants[], any[] >('features', features, signal);
        return response.data;
    },
    evaluateFeature: async function<TReturn>(feature: FeatureConstants, signal?: AbortSignal): Promise<TReturn> {
        const response = await restService.get<TReturn>(`features/${feature}`, signal);
        return response.data as TReturn;
    }
};

export default FeaturesDataService;